import React from "react";
import { Checkbox, SimpleDatePicker } from "component-library";

import {
  withEditBasicInfoContext,
  IEditBasicInfoContextProps,
} from "../../../../../../contexts/EditBasicInfoContext";
import { ControlSection } from "../../../../../Common";
import { IPregnancyViewModel } from "../../../../models/views";

export interface IPregnancyContent {
  pregnancySectionName: string;
  pregnantUntilField: string;
  isPregnantField: string;
  invalidPregnantDate: string;
  pregnantDateIsRequired: string;
}

interface IPregnancyProps extends IEditBasicInfoContextProps {
  model: IPregnancyViewModel;
  content: IPregnancyContent;
  handleChanges: (model: IPregnancyViewModel) => void;
}

export class Pregnancy extends React.Component<IPregnancyProps> {
  public render() {
    const {
      model,
      content,
      sharedState: { isPregnant, isPregnantDateInvalid },
    } = this.props;

    const untilPregnantDate = model.untilPregnantDate
      ? this.getUtcDate(new Date(model.untilPregnantDate))
      : undefined;

    return (
      <ControlSection name={content.pregnancySectionName}>
        <div className="c-basic-info-form__pregnancy">
          <div className="c-basic-info-form__pregnancy-toggle">
            <Checkbox
              htmlId="pregnancyCheckbox"
              value="pregnancy"
              name="pregnancy"
              label={content.isPregnantField}
              ariaLabel={content.isPregnantField}
              valueChanged={this.handleSelect}
              checked={isPregnant}
            />
          </div>
          <SimpleDatePicker
            key={untilPregnantDate ? "filled" : "empty"}
            name={"pregnant-until"}
            label={content.pregnantUntilField}
            value={untilPregnantDate}
            disabled={!isPregnant}
            valueChanged={this.inputChanged}
            invalid={isPregnant && isPregnantDateInvalid}
            isFormSubmitted={true}
            validationMessage={content.pregnantDateIsRequired}
            invalidDateMessage={content.invalidPregnantDate}
          />
        </div>
      </ControlSection>
    );
  }

  private handleSelect = (value: boolean) => {
    const updatedModel = { ...this.props.model };
    const isPregnantDateInvalid = value;

    updatedModel.isPregnant = value;

    if (!value) {
      updatedModel.untilPregnantDate = null;
    }

    this.props.sharedState.changeSharedState(
      { isPregnant: value, isPregnantDateInvalid },
      () => this.props.handleChanges(updatedModel)
    );
  };

  private inputChanged = (value: Date) => {
    const updatedModel = { ...this.props.model };
    let isPregnantDateInvalid = true;
    let isDateChanged = false;

    if (value) {
      const utcDate = this.getUtcDate(value);
      isPregnantDateInvalid = !Boolean(utcDate);
      updatedModel.isPregnant = true;
      updatedModel.untilPregnantDate = utcDate.toJSON();

      const previousDate = new Date(this.props.model.untilPregnantDate || 0);
      isDateChanged = utcDate.getTime() !== previousDate.getTime();

      isDateChanged &&
        this.props.sharedState.changeSharedState(
          { isPregnantDateInvalid },
          () => this.props.handleChanges(updatedModel)
        );
    }

    !isDateChanged &&
      this.props.sharedState.changeSharedState({ isPregnantDateInvalid });
  };

  private getUtcDate = (date: Date) =>
    new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
}

export default withEditBasicInfoContext(Pregnancy);
